import type { Tokens } from '../../../../theming/types'
import { styles } from '../../../../utilities'
import type { InputLabelProps } from '..'

export default (config: {
  props: Pick<InputLabelProps, 'dark'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    default: {
      label: {
        ...tokens.fontElementLabel,
        ...styles.breakWord,
        color: props.dark ? '#fff' : tokens.fontColorDefault,
        display: 'block',
      },
    },

    disabled: {
      label: {
        cursor: 'not-allowed',
        opacity: tokens.opacityDisabled,
      },
    },

    hidden: styles.visuallyHidden,
  } as const
}
